import React, { ReactElement } from "react";
import Link, { LinkProps } from "../Link/Link";

type MaybeLinkProps<T> = Omit<LinkProps<T>, "to"> & {
  to?: string;
  as?: (props: LinkProps<T>) => ReactElement;
};

// tslint:disable-next-line: function-name
function MaybeLink<T>({
  to,
  children,
  as = Link,
  ...props
}: MaybeLinkProps<T>) {
  const Link = as;
  if (typeof to === "undefined" || to === null) {
    return <>{children}</>;
  }
  return (
    <Link to={to} {...props}>
      {children}
    </Link>
  );
}

export default MaybeLink;
